{
  "version": 1,
  "asset_id": "311481c2-f93c-440d-bdb2-2094ca4bd046",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/311481c2-f93c-440d-bdb2-2094ca4bd046/checkpoint-charlie.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/311481c2-f93c-440d-bdb2-2094ca4bd046/checkpoint-charlie.jpg",
  "original_filename": "checkpoint-charlie.jpg",
  "size": 283109,
  "content_type": "image/jpeg",
  "created_at": "2026-08-18T01:12:54Z"
}
